import { render, staticRenderFns } from "./AddPoint.vue?vue&type=template&id=f4d138a8&scoped=true"
import script from "./AddPoint.vue?vue&type=script&lang=js"
export * from "./AddPoint.vue?vue&type=script&lang=js"
import style0 from "./AddPoint.vue?vue&type=style&index=0&id=f4d138a8&prod&scoped=true&lang=css"
import style1 from "./AddPoint.vue?vue&type=style&index=1&id=f4d138a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d138a8",
  null
  
)

export default component.exports